/**
 * Sovereign Platform Identity Logic
 * 
 * This file implements the Tier 2 Governance Logic for the CadOps platform.
 * It is the ONLY place in the codebase that resolves the primary domain.
 */

export const resolvePlatformIdentity = () => {
    // 1. Get values from Tier 1 (Environment)
    // We use a safe fallback for local development if the .env is not yet set.
    const domain = process.env.NEXT_PUBLIC_APP_DOMAIN || 'localhost';
    const protocol = process.env.NEXT_PUBLIC_APP_PROTOCOL || (domain === 'localhost' ? 'http' : 'https');
    
    // 2. Build the Canonical Base URL
    const isLocal = domain.includes('localhost') || domain.includes('127.0.0.1');
    const port = isLocal ? (process.env.PORT || '3000') : '';
    
    const baseUrl = `${protocol}://${domain}${port ? `:${port}` : ''}`;
    
    // 3. Resolve the canonical root domain for app subdomains
    // Stripping 'new.' prefix if present to ensure app URLs resolve to the root domain (e.g. tradesketch.cadops.com.au)
    const appDomain = domain.replace(/^new\./, '');
    
    return {
        domain,
        protocol,
        baseUrl,
        isLocal,
        // Canonical subdomains
        hubUrl: baseUrl,
        tradeSketchUrl: isLocal ? 'http://localhost:5173' : `https://tradesketch.${appDomain}`,
        cadKitUrl: isLocal ? 'http://localhost:3001' : `https://cadkit.${appDomain}`,
        
        // Helpers
        resolveSubdomain: (subdomain: string) => isLocal 
            ? `http://localhost:${subdomain === 'tradesketch' ? '5173' : '3001'}` 
            : `https://${subdomain}.${appDomain}`,
    };
};

export const platformIdentity = resolvePlatformIdentity();
